module.exports = __webpack_public_path__ + "media/images/flags/tf-cf4959c4339d5b1230931b8b44c5e9a9.svg";